import React from 'react';

/**
 * LoadingSpinner Component
 *
 * Displays a centered blue spinner with optional message.
 * Used throughout the app for loading states.
 *
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message to display below spinner
 * @param {string} [props.size='large'] - Size of spinner: 'small', 'medium', 'large'
 */
const LoadingSpinner = ({ message = 'Loading...', size = 'large' }) => {
  const sizeClasses = {
    small: 'w-6 h-6 border-2',
    medium: 'w-10 h-10 border-3',
    large: 'w-16 h-16 border-4'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] py-12">
      <div
        className={`${sizeClasses[size]} border-blue-600 border-t-transparent rounded-full animate-spin`}
      ></div>
      {message && (
        <p className="mt-4 text-slate-600 text-sm font-medium">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
